import Vue from 'vue'
import store from './stores/portfolio.js'
import Entry from './components/portfolio/Entry'
import initFilters from './modules/filter-groups.js'
import InfiniteScroll from './components/InfiniteScroll'

import {
    ContinuousCollectionComponent,
    CollectionComponent,
    SyncsWithUrl,
    ResetsPage,
} from 'clockvine-vue'

const app = new Vue({
    el: 'main',
    store,
    data: {
        params: {
            orderBy: 'title asc',
            page: 1,
            search: null,
            status: '',
            region: '',
            market: '',
        },
    },

    mounted() {
        initFilters()
    },

    computed: {
        //
    },

    methods: {
        orderby(attr) {
            if (`${attr} asc` == this.params.orderby) {
                this.params.orderBy = `${attr} desc`
            } else {
                this.params.orderBy = `${attr} asc`
            }
        },
        loadMore() {
            this.params.page += 1
        },
        clearFilters() {
            this.params.status = ''
            this.params.region = ''
            this.params.market = ''
        },

        clearSearch() {
            this.params.search = ''
        },
    },

    mixins: [
        new SyncsWithUrl('params', {
            page: () => false,
            // orderBy: 'title asc',
        }),
        new ResetsPage(),
    ],

    components: {
        portfolioCollection: ContinuousCollectionComponent.for(
            'portfolioEntries'
        ),
        portfolioMarkets: CollectionComponent.for('portfolioMarkets'),
        portfolioRegions: CollectionComponent.for('portfolioRegions'),
        InfiniteScroll,
        Entry,
    },

    computed: {},
})
